import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// Detect if a link's href goes to the current page
function getSamePageAnchor(link) {
	if (
		link.protocol !== window.location.protocol ||
		link.host !== window.location.host ||
		link.pathname !== window.location.pathname ||
		link.search !== window.location.search
	) {
		return false;
	}

	return link.hash;
}

// Scroll to a given hash, preventing the event given if there is one
export function scrollToHash(hash, e) {
	const elem = hash ? document.querySelector(hash) : false;
	if(elem) {
		if(e) e.preventDefault();

		// Pause all ScrollTriggers
		const allTriggers = ScrollTrigger.getAll();
		allTriggers.forEach(trigger => trigger.disable());

		const nav = document.getElementById('nav');
		const navHeight = nav ? nav.offsetHeight : 0;

		gsap.to(window, {
			scrollTo: {
				y: elem,
				offsetY: navHeight,
			},
			duration: 0.5,
			onComplete: () => {
				// Resume all triggers once scrolling is complete
				allTriggers.forEach(trigger => trigger.enable());
				ScrollTrigger.refresh();
			},
		});

		// Update the URL hash without jumping
		if (history.pushState) {
			history.pushState(null, null, hash);
		}
	}
}

export default function () {
	// If a link's href is within the current page, scroll to it instead
	document.querySelectorAll('a[href]').forEach(a => {
		// If the link is not a same-page anchor, skip it
		const hash = getSamePageAnchor(a);
		if (!hash) return;
		a.addEventListener('click', e => {
			scrollToHash(hash, e);
		});
	});

	// Scroll to the element in the URL's hash on load
	scrollToHash(window.location.hash);
}
